import clsx from 'clsx';
import { useMemo, memo } from 'react';

import { useTranslateFn } from '../Translate';

import type { Broadcaster } from '@shared-types/broadcaster.types';
import { parseUrl } from '@utilities/url';

const BroadcasterSingle = memo(({ broadcaster }: { broadcaster: Broadcaster }) => {
  const url = useMemo(
    () =>
      broadcaster?.url &&
      (broadcaster.url.startsWith('http') || broadcaster.url.startsWith('//')
        ? parseUrl(broadcaster.url)
        : parseUrl(`https://${broadcaster.url}`)),
    [broadcaster],
  );

  const Tag = url ? 'a' : 'div';

  if (!broadcaster) return null;

  return (
    <Tag title={broadcaster.name} data-testid={broadcaster.name} href={url} target='_blank'>
      {broadcaster?.name}
    </Tag>
  );
});
BroadcasterSingle.displayName = 'BroadcasterSingle';

export const Broadcasters = ({
  broadcasters,
  slot,
  showLabel,
  className,
}: {
  broadcasters: Broadcaster[];
  slot?: string;
  showLabel?: boolean;
  className?: string;
}) => {
  const t = useTranslateFn();
  if (!broadcasters?.length) return null;

  return (
    <div
      slot={slot}
      className={clsx(
        'pk-d--flex pk-gap--xs2 pk-font-size--xs pk-font-size-md--s pk-font--base-regular pk-text--interaction',
        className,
      )}
    >
      {showLabel && <span className='pk-text--text-01'>{t('watch_on')}</span>}
      {broadcasters.map((bc, i) => (
        <span key={bc.name}>
          <BroadcasterSingle broadcaster={bc} />
          {showLabel && i < broadcasters.length - 1 && <span className='pk-text--text-01'>, </span>}
        </span>
      ))}
    </div>
  );
};

export default memo(Broadcasters);
